import React, { useState } from 'react'
import DragAndDrop from './DragAndDrop.js'
import { MdAttachFile } from "react-icons/md";
import { BsArrowUpDown } from "react-icons/bs";
import FileAttachment_Multi from './FileAttachment_Multi'

///////////////////////////////////////////////////////
// Base 64
///////////////////////////////////////////////////////

const SignatureUpload = (props) => {
    const [encodedData, setEncodedData] = useState("");
    const [fileList, setFileList] = useState(props.valueInField)

    const uploadImageDirectoryButton = async (e) => {
        const file = e.target.files[0];
        const base64 = await convertBase64(file);
        console.log(base64);
        setEncodedData(base64);
        props.triggerUpdateFromParent(base64)
    }

    const uploadImageDragAndDropButton = async (file) => {
        const base64 = await convertBase64_dd(file);
        console.log(base64);
        setEncodedData(base64);
        props.triggerUpdateFromParent(base64)
    }

    const convertBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsDataURL(file);

            fileReader.onload = () => {
                resolve(fileReader.result)
            }

            fileReader.onerror = (error) => {
                reject(error);
            }
        })
    }

    const convertBase64_dd = (file) => {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsDataURL(file);

            fileReader.onload = () => {
                resolve(fileReader.result)
            }
            
            fileReader.onerror = (error) => {
                reject(error);
            }
        })
    }
    ///////////////////////////////////////////////////////

    ///////////////////////////////////////////////////////
    // Drag and Drop
    ///////////////////////////////////////////////////////
    const reducer = (state, action) => {
        switch (action.type) {
            case 'SET_DROP_DEPTH':
                return { ...state, dropDepth: action.dropDepth }
            case 'SET_IN_DROP_ZONE':
                return { ...state, inDropZone: action.inDropZone };
            case 'ADD_FILE_TO_LIST':
                return { ...state, fileList: state.fileList.concat(action.files) };
            default:
                return state;
        }
    };
    const [data, dispatch] = React.useReducer(
        reducer, { dropDepth: 0, inDropZone: false, fileList: [] }
    )
    ///////////////////////////////////////////////////////

    return (
        //ref="file"
        <div>
            <FileAttachment_Multi
             id={props.id}
             maxFiles={props.maxFiles}
             triggerUpdateFromParent={props.triggerUpdateFromParent}
             classesToAdd={props.classesToAdd}
             valueInField={props.valueInField}
            />
            {/*
            <p style={{ marginTop: '16px', textAlign: 'center' }}><BsArrowUpDown />&nbsp;or</p>
            <label for={props.id} class={"custom-file-upload "+props.classesToAdd}>
                <MdAttachFile /> Select from folder on your computer
            </label>
            <input id={"notUsingANymore"} type="file" name="image"
                className="unselectable"
                accept=".jpeg, .png, .jpg"
                onChange={(e) => { uploadImageDirectoryButton(e) }}
                required
            />
            <p style={{ marginTop: '16px', textAlign: 'center' }}><BsArrowUpDown />&nbsp;or</p>
            <DragAndDrop
                data={data}
                dispatch={dispatch}
                buttonText="Drag and drop a file onto here"
                maxNumOfFiles={1}
                id={props.id}
                classesToAdd={props.classesToAdd}
                funcToRun={(e) => { uploadImageDragAndDropButton(e) }}
            />
            <ol className="dropped-files">
                {data.fileList.map(f => {
                    return (
                        <li key={f.name}>{f.name}</li>
                    )
                })}
            </ol>*/}

        </div>
    )
}

export default SignatureUpload
